import { Slider } from "antd";
import { useEffect, useState } from "react";

const FormSlider = ({ title, defaultValue = 1, min = 0, max = 90, onChange = null }) => {
  const [inputValue, setInputValue] = useState(defaultValue);
  const [maxValue, setMaxValue] = useState(max);

  const handleInputChange = (e) => {
    const newValue = parseInt(e.target.value);
    setInputValue(newValue);
    if (onChange != null) {
      onChange(newValue);
    }
    if (newValue > maxValue) {
      setMaxValue(newValue * 2);
    }
  };

  return (
    <div className="form-slider">
      <div className="form-slider-title">{title}</div>
      <input
        className="form-slider-track-number"
        type="number"
        min={min}
        max={maxValue}
        value={inputValue}
        onChange={handleInputChange}
      />
      <Slider
        min={min}
        max={maxValue}
        onChange={(newValue) => {
          setInputValue(newValue);
          if (onChange != null) {
            onChange(newValue);
          }
        }}
        value={inputValue}
      />
    </div>
  );
};

export default FormSlider;
